import { useQuery } from "react-query"
import { request } from "../util/request"

export function useBandAlbumsWithSongs(bandId) {
  return useQuery(["albums_with_songs", bandId], fetchAlbumsWithSongs)
}

const fetchAlbumsWithSongs = async ({ queryKey }) => {
  const [key, bandId] = queryKey
  return await request({
    queryKey: [
      key,
      {
        path: `/api/v1/bands/${bandId}/posts`,
        params: {
          content_type: "albums",
          fields: "songs",
          per_page: 100,
          page: 1,
        },
      },
    ],
  })
}
